export const tradeByProductsLocation = "/reports/exchbusiness/tradebyproducts";
